angular
  .module('countriesApp')
  .service('SearchParamsService',
    function () {
      /**
       * Gets the articles search route with specific params
       *
       * @param {string} name - Country name for the route
       *
       * @returns {string} - Articles search route
       */
      const getArticles = name => {
        return $.param({
          'query': name,
          'filter': {
            'published_since': 'Last year'
          }
        });
      };

      /**
       * Gets the companies search route with specific params
       *
       * @param {string} name - Country name for the route
       * @param {number} id - Country id for the route
       *
       * @returns {string} - Companies search route
       */
      const getCompanies = (name, id) => {
        const officeLocationsFilter = devex.util.objectifyArray([
          {
            'name': name,
            'place_key': `country-${ id }`
          }
        ]);

        return $.param({
          'filter': {
            'types': [
              'Advocacy NGO',
              'Association',
              'Development Consulting',
              'Foundation',
              'Government',
              'Implementing NGO',
              'Independent/None',
              'Investment & Finance',
              'Service Providers',
              'Institute',
              'Works & Construction'
            ],
            'office_locations': officeLocationsFilter
          }
        });
      };

      /**
       * Gets the consultants search route with specific params
       *
       * @param {string} name - Country name for the route
       *
       * @returns {string} - Consultants search route
       */
      const getConsultants = name => $.param({
        'query': 'CEO OR CFO OR COO OR Chief OR Chief Executive Officer OR Chief Financial ' +
         'Officer OR Chief Of Party OR Chief Operating Officer OR Country Director OR Director ' +
         'OR Mission Director OR Partner OR Team Leaent OR Manager',
        'filter': {
          'has_headline': true,
          'locations': [name]
        }
      });

      /**
       * Gets the jobs search route with specific params
       *
       * @param {string} name - Country name for the route
       *
       * @returns {string} - Jobs search route
       */
      const getJobs = name => $.param({
        'filter': {
          'locations': [name]
        },
        'sorting': {
          'order': 'desc'
        }
      });

      return {
        getArticles,
        getCompanies,
        getConsultants,
        getJobs
      };
    }
  );
